/* Configurations for CMIP5, CMIP6, Cordex */
export var PROJECTNAME;
(function (PROJECTNAME) {
    PROJECTNAME["CMIP5"] = "CMIP5";
    PROJECTNAME["CMIP6"] = "CMIP6";
    PROJECTNAME["CORDEX"] = "CORDEX-CMIP6";
    PROJECTNAME["CMIP7"] = "CMIP7";
})(PROJECTNAME || (PROJECTNAME = {}));
export var Status;
(function (Status) {
    Status["IDLE"] = "IDLE";
    Status["GENERATING"] = "GENERATING";
    Status["ERROR"] = "ERROR";
    Status["READY"] = "READY";
})(Status || (Status = {}));
export var OUTPUT;
(function (OUTPUT) {
    OUTPUT["FILELIST"] = "FILELIST";
    OUTPUT["NOTEBOOK"] = "NOTEBOOK";
    OUTPUT["NA"] = "NA";
})(OUTPUT || (OUTPUT = {}));
export var OPERATION;
(function (OPERATION) {
    OPERATION["DOWNLOAD"] = "DOWNLOAD";
    OPERATION["SUBSETTING"] = "SUBSETTING";
})(OPERATION || (OPERATION = {}));
export var SUBSETTING;
(function (SUBSETTING) {
    SUBSETTING["OPENDAP"] = "OPENDAP";
    SUBSETTING["ROOK"] = "ROOK";
    SUBSETTING["NONE"] = "NONE";
})(SUBSETTING || (SUBSETTING = {}));
